<template>
  <BasicModal
    :title="isMailSent ? '採用フロー選択' : '一括変更'"
    :isShowModal="isShowModal"
    :canCancel="true"
    :width="'32%'"
    @cancel="cancel">
    <template>
      <div class="wrapper">
        <div class="content">
          <!-- メール送信後の表示 -->
          <template v-if="isMailSent">
            {{seekers.map((sk)=>sk.name+'様').join('、')}}にメールを送付しました。<br>
            ステージ・ステータスを変更しますか？
          </template>
          <!-- 一括変更時の表示 -->
          <template v-else>
            {{seekers.length}}名の応募者を選択中
          </template>
        </div>
        <div class="content">
          ステージ
          <select class="select"
            v-model="tmpStage"
            style="max-width: 240px; min-width: 240px;"
            @change="changedStage"
            >
            <option v-for="(stg, idx) in stageItems" 
            v-bind:value="stg"
            :key="idx">
              {{ stg.name }}
            </option>
          </select>
        </div>
        <div class="content">
          ステータス
          <select class="select"
            v-model="tmpStatus"
            style="max-width: 240px; min-width: 240px;"
            >
            <option v-for="(st, idx) in statusItems" 
            v-bind:value="st" 
            :key="idx">
              {{ st.name }}
            </option>
          </select>
        </div>
      </div>
    </template>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button is-light" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="setStageStatus(); $emit('cancel', null, false)" :disabled="!isValid">
        保存する
      </button>
    </div>
    <slot></slot>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    changeRecruitmentFlow: {
      type: Function,
      required: true
    },
    seekers: {
      required: true
    },
    isMailSent() {
      // seekersが1件のみの場合はメール送信後と判断
      return this.seekers.length === 1
    },
    recruitmentFlows: {
      require: true
    },
  },
  computed: {
    stageItems () {
      return this.recruitmentFlows[0].stages.filter((s)=>!s.is_delete_apply)
    },
    statusItems () {
      if (this.tmpStage) return this.tmpStage.status.filter((s)=>!s.is_delete_apply)
      else return []
    },
    isValid() {
      return this.seekers && this.seekers.length > 0 && this.tmpStage && this.tmpStatus
    },
    modalTitle() {  // タイトルを動的に変更
      return this.isAfterEmail ? '採用フロー選択' : 'ステージ・ステータス一括変更'
    },
  },
  data () {
    return {
      tmpStage:null,
      tmpStatus:null,
    }
  },
  mounted() {
    if (this.seekers.length == 1) {
      this.tmpStage = this.recruitmentFlows[0].stages.find((stg)=>stg.pk==this.seekers[0].recruitment_flow_stage)
      this.tmpStatus = this.tmpStage.status.find((st)=>st.pk==this.seekers[0].recruitment_flow_status)
    }
    else {
      this.tmpStage = null
      this.tmpStatus = null
    }
  },
  methods: {
    changedStage () {
      this.tmpStatus = null
    },
    setStageStatus () {
      this.sendControlLog('応募者ステージ&ステータス変更', 'ステージ&ステータス選択モーダルにて、「保存する」ボタンをクリックした。')
      for (let sk of this.seekers) {
        sk.recruitment_flow_stage = this.tmpStage.pk
        sk.recruitment_flow_status = this.tmpStatus.pk
      }
      this.changeRecruitmentFlow(this.seekers)
    },
    cancel () {
      this.$emit('cancel', null, false)
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin-left: 24px;
  margin-right: 24px;
}

.content {
  margin-top: 12px;
  margin-bottom: 12px;
}

.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/ModalStageStatus.vue